import { invoiceEntityMutations } from './invoice';
import { outsourceInvoiceMutations } from './outsourceInvoices';
import { packagesMutations } from './packages';
import { projectInvoicesMutations } from './projectInvoices';
import { invoiceProjectsMutations } from './projects';
import { quotationRequestMutations } from './quotationRequests';

export const invoiceMutations = {
  ...packagesMutations,

  ...quotationRequestMutations,

  ...invoiceProjectsMutations,

  ...invoiceEntityMutations,

  ...projectInvoicesMutations,

  ...outsourceInvoiceMutations,
};
